import { createFileRoute } from '@tanstack/react-router'
import EditProfile from '@/modules/editProfile'

export const Route = createFileRoute('/edit-profile')({
  component: EditProfile,
})
